import BankService from "@/service/BankService";
import MenuRightSerivce from "@/service/MenuRightService";
import SweetAlertService from "@/service/SweetAlertService";
import StoreGetter from "@/constants/StoreGetter";
import { Banks } from "@/model/Banks";
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import banksValidationObj from "./S080900-BanksValidation.js";
import Paginate from "vuejs-paginate";
import Settings from "../../../constants/Settings.js";
var banksDataValidationObj = new banksValidationObj();
export default {
  name: "bank",
  mounted() {
    banksDataValidationObj.bankValidation();
    this.assignRights();
    this.resetBankData();
    this.init();
    this.getAllBanks();
  },
  components: {
    paginate: Paginate,
  },
  data: () => ({
    menuRights: { allRights: {}, rightsForThisMenu: {} },
    menuId: Settings.MenuID.S_Bank,
    Settings: Settings,
    dictEnum: dictEnum,
    banks: new Banks(),
    isEditMode: false,
    banksList: [],
    selectAllBank: false,
    tempBankModel: new Banks(),
    take: 10,
    skip: 0,
    totalNoOfPages: 0,
    noOfPages: 5,
    currentSelectedPage: 0,
    currentPage: 1,
    totalRecords: 0,
  }),
  computed: {
    t() {
      return t;
    },
    user() {
      return this.$store.getters[StoreGetter.user];
    },
  },
  methods: {
    init() {
      var self = this;
      var documentHeight = $(document).height();
      var headerHeight = $("nav").height();
      var tabHeight = $(".tab-header-section").height();
      var tableHeaderHeight = $(".bank-table table thead").height();
      var pagginationHeight = $(".paggination-bank").height();
      var docHeight = documentHeight != undefined ? documentHeight : 666;
      var headHeight = headerHeight != undefined ? headerHeight : 59;
      var tabHeaderHeight = tabHeight != undefined ? tabHeight : 36;
      var tHeadHeight = tableHeaderHeight != undefined && tableHeaderHeight != 0 ? tableHeaderHeight : 38;
      var paggHeight = pagginationHeight != undefined && pagginationHeight != 0 ? pagginationHeight : 22;
      var tableHeight = docHeight - headHeight - tabHeaderHeight - tHeadHeight - paggHeight - 70;
      self.take = Number((tableHeight / 39).toFixed());
    },
    hasRight(key, menuId) {
      if (Object.keys(this.menuRights.allRights).length === 0) {
        return false;
      } else {
        return MenuRightSerivce.hasRightInMenu(
          this.menuRights.allRights,
          menuId ? menuId : this.menuId,
          key
        );
      }
    },
    assignRights() {
      this.menuRights.allRights = this.$store.getters[StoreGetter.sysMenu];
      this.menuRights.rightsForThisMenu = this.menuRights.allRights.find(
        x => x.MenuID == this.menuId
      );
    },
    async getAllBanks() {
      var self = this;
      var obj = {
        take: self.take,
        skip: self.skip,
      }
      const response = await BankService.getAllBanksByPagination(obj);
      if (response.data.IsSuccess) {
        self.banksList = response.data.Data.Item1;
        self.totalRecords = response.data.Data.Item2;
        self.totalPages();
        if (response.data.Data.Item1.length == 0 && response.data.Data.Item2 > 0) {
          self.changePage(self.currentPage - 1);
        }
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async getBankDetail() {
      var self = this;
      const obj = {
        bankCode: self.tempBankModel.BankCode,
      };
      const response = await BankService.getBankDetailByBankCode(obj);
      if (response.data.IsSuccess) {
        self.banks = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    selectAllBankRecord: function () {
      var self = this;
      var IsSelected = self.selectAllBank;
      self.banksList.forEach(function (val, index) {
        val["isSelected"] = IsSelected;
      });
    },
    deleteMultipleBankPopup: function () {
      var arrayList = [];
      var self = this;
      self.banksList.forEach(function (key, value) {
        if (key.isSelected) {
          arrayList.push(key);
        }
      });
      if (arrayList.length > 0) {
        $('#deleteBankModel').modal('show');
      }
      else {
        SweetAlertService.warning("Warn", self.t.t(dictEnum.MSG_SelectDeleteRecord));
      }
    },
    async deleteMultipleBank() {
      var arrayList = [];
      var self = this;
      $('#deleteBankModel').modal('hide');
      self.banksList.forEach(function (key, value) {
        if (key.isSelected) {
          arrayList.push(key);
        }
      });
      const obj = {
        bankList: arrayList,
      };
      const response = await BankService.deleteBank(obj);
      if (response.data.IsSuccess) {
        SweetAlertService.success("Success", response.data.Message);
        self.resetBankData();
        self.init();
        await self.getAllBanks();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    OnBankSelect: function (model) {
      this.tempBankModel = model;
    },
    addBank: function () {
      var self = this;
      $('#bankModel').modal('show');
      self.isEditMode = false;
      self.banks = new Banks();
      self.$validator.reset();
      self.vErrors.clear();
    },
    async saveBankData(obj) {
      var self = this;
      const response = await BankService.addBank(obj);
      if (response.data.IsSuccess) {
        SweetAlertService.success("Success", response.data.Message);
        self.resetBankData();
        self.init();
        await self.getAllBanks();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async EditBankData(obj) {
      var self = this;
      const response = await BankService.updateBank(obj);
      if (response.data.IsSuccess) {
        SweetAlertService.success("Success", response.data.Message);
        self.resetBankData();
        self.init();
        await self.getAllBanks();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async saveBank() {
      var self = this;
      self.$validator.validateAll().then(result => {
        if (result) {
          $('#bankModel').modal('hide');
          const obj = {
            model: {
              BankCode: self.banks.BankCode,
              CName: self.banks.CName,
              EName: self.banks.EName
            }
          };
          if (self.isEditMode) {
            self.EditBankData(obj);
          }
          else {
            self.saveBankData(obj);
          }
        }
      });
    },
    async editBank() {
      var self = this;
      self.isEditMode = true;
      if (self.tempBankModel.BankCode != "") {
        await self.getBankDetail();
        self.$validator.reset();
        self.vErrors.clear();
        $('#bankModel').modal('show');
      }
      else {
        SweetAlertService.warning("Warn", self.t.t(dictEnum.MSG_SelectEditRecord));
      }
    },
    resetBankData: function () {
      var self = this;
      self.selectAllBank = false;
      self.isEditMode = false;
      self.banks = new Banks();
      self.tempBankModel = new Banks();
      self.$validator.reset();
      self.vErrors.clear();
      self.take = 10;
      self.skip = 0;
      self.totalNoOfPages = 0;
      self.noOfPages = 5;
      self.currentSelectedPage = 0;
      self.currentPage = 1;
      self.totalRecords = 0;
    },
    closeBankPopup: function () {
      var self = this;
      self.selectAllBank = false;
      self.isEditMode = false;
      self.banks = new Banks();
      self.tempBankModel = new Banks();
      self.$validator.reset();
      self.vErrors.clear();
      $('#bankModel').modal('hide');
    },
    //Pagination Method start
    changePage(pagenumber) {
      this.currentPage = pagenumber;
      this.setPage();
    },
    setPage() {
      this.skip = this.take * (this.currentPage - 1);
      this.getAllBanks();
    },
    totalPages() {
      var numbers = this.totalRecords / this.take;
      var pages = 0;
      if (Number.isInteger(numbers)) {
        pages = numbers;
      } else {
        pages = Math.floor(numbers) + 1;
      }
      this.totalNoOfPages = pages;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/S080000-Setup/S080900-Banks/S080900-Banks.js